import Navigation from "../components/utils/Navigation";
import NoDataAvailable from '../components/utils/NoDataAvailable';
import PCLink from '../components/utils/PCLink';
import SARepoView from '../components/dialogs/view/SARepoView';
import { getMapWithCategoriesAndPlatformTypes, waitSeconds } from "../utils/utilitiesmodule";
import { deleteServiceAccount, duplicateServiceAccount } from "../utils/entityMethods/serviceAccount";

export default {
    name: "Accounts",
    data() {
        return {
            serviceAccounts: null,
            serviceAccountsTypes: null,
            filter_type: -1,
            filter_name: '',
            selectedType: -1,
            selectedIndex: -1,
            accselected: null,
            accountselected: null,
            computers: [],

            microsoftTypes: [],
            emailTypes: [],
        };
    },
    props: {
        msg: String,
    },
    components: {

        NoDataAvailable,
        Navigation,
        SARepoView,
        PCLink
    },
    watch: {
        '$route': {
            handler: function(to) {
                if (to.hash=="")
                    return;
                var action, idServiceAccount;
                if (!to.hash.contains(":")) {
                    action="";
                    idServiceAccount=to.hash.replace("#", "");
                } else {
                    [action, idServiceAccount]=to.hash.split(":");
                }
                //to.hash= #[action]:[idServiceAccount]
                var selectedSA=this.$session.getServiceAccountWithID(idServiceAccount);
                switch (action) {
                    case "#delete":
                        this.deleteServiceAccount(selectedSA);
                        return;

                    case "#details":
                        this.$root.$emit("OPENSAREPOVIEW", selectedSA);
                        return;
                    case "#duplicate":
                        this.duplicateServiceAccount(selectedSA);
                        return;
                    case "#openpc":
                        this.$router.replace("/computers/computer/"+idServiceAccount);
                        return;
                    default:
                        this.$root.$emit('OPENSERVICEACCOUNTDIALOG', selectedSA);
                }

            },
            deep: true,
            immediate: true
        }
    },
    beforeDestroy: function() {
        //this.$root.$emit("CLOSEALLDIALOGS");
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        this.$root.$off("REFRESHSERVICEACCOUNTS");
        this.serviceAccounts=null; // Pulire i dati memorizzati
        this.computers=null;
        //alert("destroy accounts.JS");
        //this.$root.checkConnectionTimerAction("stop");
        //this.$root.newPage("accounts", "destroy");
    },
    created: function() {
        this.serviceAccountsTypes=getMapWithCategoriesAndPlatformTypes("forServiceAccount", true);
        //alert("CREATED COMPUTERS.JS");
        //this.$root.newPage("accounts", "created");
        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        this.serviceAccounts=this.$session.getServiceAccounts();
        let self=this;
        this.$root.$on("REFRESHSERVICEACCOUNTS", () => {
            self.serviceAccounts.clear();
            waitSeconds(0.1).then(_ => {
                self.serviceAccounts.update(self.$session.getServiceAccounts());

            })
        });

        this.microsoftTypes=this.$root.getMicrosoftTypes();
        this.emailTypes=this.$root.getEmailTypes();
    },
    mounted: function() {
        //this.$root.newPage("accounts", "mounted");
        this.$session.setRoomPC(null);
        this.computers=this.$session.getPCList();
    },

    methods: {
        deleteServiceAccount,
        duplicateServiceAccount,
        /***************************************PC********************************/

        see(sa) {
            this.accountselected=sa;
            window.Metro.charms.toggle("#accountselected");
        },



        closeCharm() {
            window.Metro.charms.toggle("#reposelected");
        }
    },
}